/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';
import { BooleanInput } from './BooleanInput';
import type { Props as BooleanInputProps } from './BooleanInput';

type Props = Omit<BooleanInputProps, 'type'>;

export const Checkbox = (props: Props) => (
  <BooleanInput {...props} type="checkbox" />
);

Checkbox.defaultProps = {
  tabIndex: 0,
};
